import BaseError from '../../utils/BaseError'

/**
 * ApiError to represent Api response errors
 * @extends BaseError
 */
export class ApiError extends BaseError {
  constructor(status, statusText, response) {
    super(`${status} - ${statusText}`)

    this.status = status
    this.statusText = statusText
    this.response = response
  }

  get errorCode() {
    return this.response.response.code
  }

  get errorMessage() {
    return this.response.response.message
  }
}

/**
 * RequestError to represent Api request errors
 * @extends BaseError
 */
export class RequestError extends BaseError {}

/**
 * RequestError to represent Api internal errors
 * @extends BaseError
 */
export class InternalError extends BaseError {}
